export function setTitle(title) {
  const suffix = "The Bistro |";
  document.title = `${suffix} ${title}`;
}